import flatpickr from 'flatpickr';
import { Danish } from 'flatpickr/dist/l10n/da';
// TODO: Flatpickr is missing support for greenlandic
import Cleave from 'cleave.js';
import 'cleave.js/dist/addons/cleave-phone.dk';
import 'cleave.js/dist/addons/cleave-phone.gl';

import { LocaleUtils } from './locale-utils';

export function getDefaultEndTime(startDate: Date): Date {
	const oneDayInMs = 24 * 60 * 60 * 1000;
	return new Date(startDate.getTime() + oneDayInMs);
}

export function initPhone(selector: string): void {
	document.querySelectorAll(selector).forEach((el: HTMLElement) => {
		new Cleave(el, {
			phone: true,
			phoneRegionCode: LocaleUtils.getRegionName(),
		});
	});
}

export function initCpr(selector: string): void {
	new Cleave(selector, {
		numericOnly: true,
		delimiter: '-',
		blocks: [6, 4],
	});
}

export function initDatePicker(
	selector: string,
	onChange: (selectedDates: Date[]) => void,
	defaultDate?: Date,
): any {
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
	const maxDate = new Date(now.getFullYear() + 2, 11, 31);
	const datePicker = flatpickr(selector, {
		locale: Danish,
		allowInput: true,
		altInput: true,
		altFormat: 'd.m.Y',
		dateFormat: 'd.m.Y',
		minDate: today,
		maxDate: maxDate,
		onReady: function () {
			new Cleave(this.altInput, {
				date: true,
				delimiter: '.',
				datePattern: ['d', 'm', 'Y'],
			});
		},
		onChange: onChange,
	}) as any;
	datePicker.setDate(defaultDate ?? now);
	// make sure value is set when tabbing out of the field
	datePicker._input.addEventListener(
		'blur',
		() => {
			const value = datePicker._input.value;
			datePicker.setDate(value, true, 'd.m.Y');
		},
		true,
	);
	return datePicker;
}

export function initTimePicker(
	selector: string,
	onChange: (selectedDates: Date[]) => void,
	defaultDate?: Date,
): any {
	const timePicker = flatpickr(selector, {
		locale: Danish,
		allowInput: true,
		altInput: true,
		altFormat: 'H:i',
		dateFormat: 'H:i',
		enableTime: true,
		noCalendar: true,
		clickOpens: false,
		time_24hr: true,
		onReady: function () {
			new Cleave(this.altInput, {
				time: true,
				timePattern: ['h', 'm'],
			});
		},
		onChange: onChange,
	}) as any;
	timePicker.setDate(defaultDate ?? new Date());
	// make sure value is set when tabbing out of the field
	timePicker._input.addEventListener(
		'blur',
		() => {
			const value = timePicker._input.value;
			timePicker.setDate(value, true, 'H:i');
		},
		true,
	);
	return timePicker;
}
